// fallow-ignore-file boundary-violation
import {
    aiResearchNavBarContent,
    digitalSuiteSearchInterestNavBarContent,
    industryAnalysisNavBarContent,
    industryResearchNavBarContent,
} from "app/components/sidebar3/dynamic-config/configs/sidebar31/nav-bar-content/navBarContent";
import type { SecondarySidebarMap } from "app/components/sidebar3/dynamic-config/types";
import {
    conversionAnalysisNavBarContents,
    dashboardsNavBarContents,
    digitalSuiteAdvertiserActivityNavBarContent,
    digitalSuiteBacklinksAnalysisNavBarContent,
    digitalSuiteKeywordResearchNavBarContent,
    digitalSuitePublisherAnalysisNavBarContent,
    digitalSuiteSearchTrackingNavBarContent,
    digitalSuiteSegmentAnalysisNavBarContent,
    digitalSuiteWebsiteAnalysisNavBarContent,
    monitorAndProtectNavBarContent,
} from "app/components/sidebar3/secondary-side-bar/Utils/SecondarySideBarResolver";
import { SecondarySideBarType3 } from "app/components/sidebar3/types";
import {
    salesAdvertiserActivityNavBarContent,
    salesMonitorAndProtectNavBarContent,
    salesPublisherAnalysisNavBarContent,
} from "app/pages/sales-intelligence";

const {
    IndustryAnalysis,
    IndustryResearch,
    SearchInterest,
    WebsiteAnalysis,
    SegmentAnalysis,
    KeywordResearch,
    BacklinksAnalysis,
    Dashboards,
    ConversionAnalysis,
    SearchTracking,
    None,
    PremiumFeatures,
    AdvertiserActivity,
    PublisherAnalysis,
    MonitorAndProtect,
    SalesAdvertiserActivity,
    SalesPublisherAnalysis,
    SalesMonitorAndProtect,
    AIResearch,
} = SecondarySideBarType3;

export const secondarySidebarMap: SecondarySidebarMap = {
    [AIResearch]: aiResearchNavBarContent,
    [IndustryAnalysis]: industryAnalysisNavBarContent,
    [IndustryResearch]: industryResearchNavBarContent,
    [SearchInterest]: digitalSuiteSearchInterestNavBarContent,
    [WebsiteAnalysis]: digitalSuiteWebsiteAnalysisNavBarContent,
    [SegmentAnalysis]: digitalSuiteSegmentAnalysisNavBarContent,
    [Dashboards]: dashboardsNavBarContents,
    [ConversionAnalysis]: conversionAnalysisNavBarContents,
    [SearchTracking]: digitalSuiteSearchTrackingNavBarContent,
    [KeywordResearch]: digitalSuiteKeywordResearchNavBarContent,
    [BacklinksAnalysis]: digitalSuiteBacklinksAnalysisNavBarContent,
    [None]: () => null,
    [PremiumFeatures]: () => null,
    [AdvertiserActivity]: digitalSuiteAdvertiserActivityNavBarContent,
    [PublisherAnalysis]: digitalSuitePublisherAnalysisNavBarContent,
    [MonitorAndProtect]: monitorAndProtectNavBarContent,
    [SalesAdvertiserActivity]: salesAdvertiserActivityNavBarContent,
    [SalesPublisherAnalysis]: salesPublisherAnalysisNavBarContent,
    [SalesMonitorAndProtect]: salesMonitorAndProtectNavBarContent,
};
